import ExportForm from "../common/ExportForm";
const EXPORT_COLUMNS = [
	{ key: "firstName", label: "First Name" },
	{ key: "middleName", label: "Middle Name" },
	{ key: "lastName", label: "Last Name" },
	{ key: "organizationName", label: "Organization Name" },
	{ key: "role", label: "Role" },
	{ key: "email1", label: "Email 1" },
	{ key: "email2", label: "Email 2" },
	{ key: "phoneNumber", label: "Business Phone" },
	{ key: "extension", label: "Extension" },
	{ key: "fax", label: "Fax" },
	{ key: "directNumber", label: "Direct Number" },
	{ key: "street", label: "Street" },
	{ key: "city", label: "City" },
	{ key: "state", label: "State" },
	{ key: "zipCode", label: "Zip Code" },
	{ key: "overseaAddress", label: "Oversea Address" },
	{ key: "background", label: "Background" },
	{ key: "void", label: "Void" }, 
	{ key: "voidReason", label: "Void Reason" }, 
	{ key: "validateReason", label: "Validate Reason" }, 
	{ key: "creatorId", label: "Creator" },
	{ key: "createdAt", label: "Created At" }, 
	{ key: "updaterId", label: "Updater" }, 
	{ key: "updatedAt", label: "Updated At" }, 
];
export default function ContactExportForm(){
	return (<ExportForm columns = {EXPORT_COLUMNS}/>);
}
